import React from 'react';
import Layout from '../../components/Layout';
import NotFound from '../notFound/NotFound';
import fetch from '../../core/fetch';
import Blog from './blog';

export default {

    path: '/page/:u1?',

    async action(store, params, path) {
        let blogUrl = '';

        blogUrl = params.u1;

        let title = 'Static Page';
        let description = '';

        const query = `
        query getBlogHome ($pageUrl: String!) {
        getBlogHome (pageUrl: $pageUrl) {
            id
            metaTitle
            metaDescription
            pageUrl
            pageTitle
            contentParsed
            footerCategory
            isEnable
            createdAt
            coverPhoto
            blogPhotos {
                number
                name
            }
        }
        }
    `;

        const paramsValue = {
            pageUrl: blogUrl
        };

        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: paramsValue
            }),
            credentials: 'include',
        });

        const { data } = await resp.json();

        if (data && data.getBlogHome) {
            title = data.getBlogHome.pageTitle;
            description = data.getBlogHome.metaDescription;
            /* let blogPhotos = data.getBlogHome.blogPhotos;
            let content = data.getBlogHome.content;
            if( blogPhotos && /\[\[(\d{1,2})(?:\|(.+?)){0,5}\]\]/.test(data.getBlogHome.content) ) {
              //const blogPhotos = await BlogPhotos.findAll({
              //  where: { blogId: id },
              //  attributes: ['number', 'name'],
                // include: [
                //  { model: BlogDetails, as: 'blogDetails', where: { id: blogId } }
                //]
              //});
              
              const photosMap = new Map(blogPhotos.map(photo => [photo.number, photo.name]));
              content = content.replace(/(\<p\>)?\[\[(\d{1,2})(\|.+?)?\]\](\<\/p\>)?/g, (match, p1, p2, p3, p4) => {
                let attributes = {alt: '', caption: ''};
                if( p3 ) {
                  [...p3.matchAll(/\|([a-z]):(.+?)(?=\|[a-z]:|$)/gi)].forEach(e => {
                    switch( e[1] ) {
                      case 'a':
                        attributes.alt = e[2];
                        break;
                      case 'c':
                        attributes.caption = e[2];
                        break;
                    }
                  });
                }
                return (p1 && !p4 ? p1 : '') + '<figure class="blogFigure"><img src="/images/blog/' + photosMap.get(Number(p2)) + '" class="blogPhoto" />' + ( attributes.caption ? '<figcaption>' + attributes.caption + '</figcaption>' : '' ) + '</figure>' + (!p1 && p4 ? p4 : '');
              });
            } */
            return {
                title,
                description,
                component: <Layout><Blog title={title} description={description} initialValues={data.getBlogHome}></Blog></Layout>,
            };
        }
        else {
            title = "Not Found"
            return {
                title,
                component: <Layout><NotFound title={title} /></Layout>,
                status: 404,
            };
        };
    },

};




// WEBPACK FOOTER //
// src/routes/blog/index.js